import { Container } from 'react-bootstrap'
import Image from 'next/image'
import { useState, useEffect } from 'react'
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

export default function OverviewFeaturedStats(props){
    const site = props.global.site
    const auth = props.global.auth

    const arr = auth.name.split(' ')

    let contactAccount = props.contactAccount
    const [contactId, setContactId] = useState(null);

    let point = 0;
    let badges = 0;
    let reviews = 0;
    let events = 0;

    const [data, setData] = useState({ 
        firstname: arr[0],  
        lastname: arr[1],
    })

    useEffect(() => {

        if(typeof contactAccount != 'undefined'){
                setData({ 
                firstname: contactAccount ? contactAccount.contact.profile.firstname : "",  
                lastname: contactAccount ? contactAccount.contact.profile.lastname : ""
            })

            setContactId(contactAccount.contact_id)
        }
        
    }, [contactAccount]);

    if(auth.site_user){

        const contact_id = contactId;
        const { data: iqPoints} = request.stats.IQPoints(contact_id);
        const { data: badgesEarned} = request.stats.badgesEarned(contact_id);
        const { data: reviewsGiven} = request.stats.reviewsGiven(contact_id);


        if(iqPoints){
            point = iqPoints.points;
        }

        if(badgesEarned){
            badges = badgesEarned.points;
        }

        if(reviewsGiven){
            reviews = reviewsGiven.points;
        }

    }


    return(
        <div className="overview-feat-stats ">
            <Container className="pb-5">
                <h2 className="text-center font-weight-bold mt-3 mb-5 pb-3">Way to go {data.firstname} You’re an Ace Attendee!</h2>
                <div className="feat-list text-center my-4 pt-4">
                    <div>
                    <p className="icon-text"><img src="/images/learnandearn/img-wellness-iq-points.svg" /><span>{point}</span></p>
                    <p className="icon-title">Wellness IQ Points</p>
                    </div>
                    <div>
                    <p className="icon-text"><img src="/images/learnandearn/img-badges-earned.svg" /><span>{badges}</span></p>
                    <p className="icon-title">Badges Earned</p>
                    </div>
                    <div>
                    <p className="icon-text"><img src="/images/learnandearn/img-events-attended.svg" /><span>{events}</span></p>
                    <p className="icon-title">Events Attended</p>
                    </div>
                    <div>
                    <p className="icon-text"><img src="/images/learnandearn/img-reviews-given.svg" /><span>{reviews}</span></p>
                    <p className="icon-title">Reviews Given</p>
                    </div>
                </div>
            </Container>
            <hr className="divider mx-auto "/>
            <style jsx>{`
                .icon-text span{
                    font-size: 3rem;
                    display: inline-block;
                    margin-left: 1.5rem;
                    line-height:0;
                    font-weight: 600;
                }
                .icon-text strong{
                    margin-left: 1rem;
                }
                .icon-text{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .icon-title{
                    font-size: 1.13rem;
                }
                .overview-feat-stats .feat-list{
                    display: grid!important;
                    align-items: center;
                    grid-template-columns: repeat(auto-fit, minmax(217px, 1fr));
                    grid-gap: 20px;
                    justify-content: center;
                }
               
            `}</style>
        </div>
    )
}